export const BILLING = 'BILLING'
export const BILLING_PLANS = 'BILLING_PLANS';
export const BILLING_CHARGED = 'BILLING_CHARGED';
export const BILLING_CUSTOMER = 'BILLING_CUSTOMER';
export const BILLING_INVOICE = 'BILLING_INVOICE';
export const BILLING_PAYMENT_METHODS = 'BILLING_PAYMENT_METHODS';
export const BILLING_CLEAN_PAYMENT_METHODS = 'BILLING_CLEAN_PAYMENT_METHODS';
export const BILLING_CANCEL = 'BILLING_CANCEL';
export const BILLING_CALCULATE_COUPON = 'BILLING_CALCULATE_COUPON';
export const BILLING_CLEAR_CALCULATE_COUPON = 'BILLING_CLEAR_CALCULATE_COUPON';